// extracted by mini-css-extract-plugin
export var active = "_aj-7";
export var container = "_aj-0";
export var evenWidth = "_aj-4";
export var large = "_aj-5";
export var outlet = "_aj-8";
export var slide = "_aj-2";
export var small = "_aj-6";
export var tab = "_aj-3";
export var tabs = "_aj-1";